import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GameService } from '../../shared/services/game.service';
import { APP_ROLE, SOCKET_ERROR, SocketService } from '../../shared/services/socket.service';
import { StorageService } from '../../shared/services/storage.service';


@Injectable()
export class CanActivateRemoteGameSettingsGuard implements CanActivate {
  constructor(private _socketService: SocketService, private _gameService: GameService, private _storageService: StorageService, private _router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this._storageService.getSessionCode().map((sessionCode) => {
      if (sessionCode != null) {
        console.warn('sessionCode already found!');
        return Observable.of(false);
      } else {
        return Observable.of(true);
      }

    }).flatMap((e: Observable<boolean>) => {
      return e.map((val) => {
        if (val === true) {
          return true;
        } else {
          this._router.navigate(['/remote/game']);
          return false;
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/remote/settings/can-activate-remote-game-settings.guard.ts